import React from "react";
import { useLang } from "@/lib/useLang";
import Analytics from "@/lib/analytics";

export const LangToggle = () => {
  const { lang, setLang, t } = useLang();
  const change = (next) => {
    if (next !== lang) Analytics.languageToggle(next);
    setLang(next);
  };
  return (
    <div
      className="lang-toggle"
      role="group"
      aria-label={t("lang_toggle_label")}
      data-testid="lang-toggle"
    >
      <button
        type="button"
        aria-pressed={lang === "en"}
        onClick={() => change("en")}
        data-testid="lang-en-btn"
      >
        EN
      </button>
      <button
        type="button"
        aria-pressed={lang === "ml"}
        onClick={() => change("ml")}
        data-testid="lang-ml-btn"
        aria-label="Malayalam"
        style={{ fontFamily: "'Noto Sans Malayalam', 'Work Sans', sans-serif", letterSpacing: "0.04em" }}
      >
        മല
      </button>
    </div>
  );
};

export default LangToggle;
